import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "message-plugin"
};
var _hoisted_2 = {
  key: 0,
  class: "message-plugin-tip"
};
import { computed } from '../../adapter-vue';
import { TUIStore } from '@tencentcloud/chat-uikit-engine';
import MessageBubble from '../../components/TUIChat/message-list/message-elements/message-bubble.vue';
import { isUniFrameWork } from '../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-plugin-layout',
  props: {
    message: {
      default: () => ({})
    },
    showStyle: {
      default: ''
    },
    bubbleClassNameList: {
      default: () => []
    },
    blinkMessageIDList: {
      default: () => []
    }
  },
  emits: ['resendMessage', 'handleToggleMessageItem', 'handleH5LongPress'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var messageModel = computed(() => {
      var _props$message;
      return TUIStore.getMessageModel((_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.ID);
    });
    // 以下为messageTool等外部交互使用，无需特殊处理，勿动
    var resendMessage = message => {
      emits('resendMessage', message);
    };
    var handleToggleMessageItem = function handleToggleMessageItem(e, message) {
      var isLongpress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      emits('handleToggleMessageItem', e, message, isLongpress);
    };
    var handleH5LongPress = (e, message, type) => {
      emits('handleH5LongPress', e, message, type);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [props.showStyle === 'tip' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "messageTip")])) : props.showStyle === 'bubble' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "message-plugin-bubble-content",
        onLongpress: _cache[1] || (_cache[1] = $event => handleToggleMessageItem($event, _unref(messageModel), true)),
        onContextmenu: _cache[2] || (_cache[2] = _withModifiers($event => handleToggleMessageItem($event, _unref(messageModel)), ["prevent", "right"])),
        onTouchstart: _cache[3] || (_cache[3] = $event => handleH5LongPress($event, _unref(messageModel), 'touchstart')),
        onTouchend: _cache[4] || (_cache[4] = $event => handleH5LongPress($event, _unref(messageModel), 'touchend')),
        onMouseover: _cache[5] || (_cache[5] = $event => handleH5LongPress($event, _unref(messageModel), 'touchend'))
      }, [_createVNode(MessageBubble, {
        messageItem: _unref(messageModel),
        content: _unref(messageModel).getMessageContent(),
        blinkMessageIDList: props.blinkMessageIDList,
        classNameList: props.bubbleClassNameList,
        onResendMessage: _cache[0] || (_cache[0] = $event => resendMessage(_unref(messageModel)))
      }, {
        messageElement: _withCtx(() => [!_unref(isUniFrameWork) ? _renderSlot(_ctx.$slots, "messageBubble", {
          key: 0
        }) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_unref(isUniFrameWork) ? _renderSlot(_ctx.$slots, "messageBubble", {
          key: 0
        }) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["messageItem", "content", "blinkMessageIDList", "classNameList"])], 32)) : _createCommentVNode("", true)]);
    };
  }
});